module.exports = __webpack_public_path__ + "static/img/manual_zh_30.b541dea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_30.png
// module id = q2vF
// module chunks = 4